import React from 'react';
import classNames from 'classnames';

import LoaderIcon from './../loader/LoaderIcon';
import { ButtonColor, ButtonType } from './models/ButtonModels';
import {
  getClassesForButtonColor,
  getClassesForButtonType,
  getDisabledButtonClasses,
  getLoaderText,
  LoaderProps
} from './utils/buttonHelpers';

type PrimaryButtonProps = {
  text?: string | React.ReactElement;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  link?: string;
  disabled?: boolean;
  useLoader?: LoaderProps;
  className?: string;
  buttonColor?: ButtonColor;
  buttonType?: ButtonType;
  id?: string;
  chevron?: boolean;
};

const PrimaryButton = ({
  text,
  onClick,
  link,
  disabled,
  useLoader,
  className,
  buttonColor,
  buttonType,
  id,
  chevron
}: PrimaryButtonProps) => {
  const classes = classNames(className, getClassesForButtonType(buttonType || ButtonType.Action), {
    [getClassesForButtonColor(buttonColor || ButtonColor.Red)]: !disabled,
    [getDisabledButtonClasses()]: disabled
  });

  const chevronColor = chevron && buttonColor === 'NavyBlue' ? 'border-t-ev-navy-blue-3' : 'border-t-white';

  const buttonComponent = (
    <button onClick={onClick} className={classes} disabled={disabled} id={id}>
      {useLoader && (
        <>
          <LoaderIcon
            icon={useLoader.done?.check ? useLoader.done.icon : useLoader.default.icon}
            light={true}
            loading={useLoader.loading.check}
          />
          &nbsp;
          {getLoaderText(useLoader)}
        </>
      )}
      {!useLoader && text}
    </button>
  );

  if (link) {
    return (
      <a href={link} className={classes} target="_blank" rel="noreferrer">
        {text}
      </a>
    );
  }

  if (chevron) {
    return (
      <div className="group">
        {buttonComponent}

        {chevron && (
          <div
            className={`group-hover:hidden mx-auto w-0 h-0 border-l-[5px] border-r-[5px] border-t-[5px] border-l-transparent border-r-transparent border-solid ${chevronColor}`}
          />
        )}
      </div>
    );
  }
  return buttonComponent;
};

export default PrimaryButton;
